import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router';
import {
  AppBar,
  Avatar,
  Badge,
  Box,
  Collapse,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import {
  Menu as MenuIcon,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Notifications,
} from '@mui/icons-material';
import { findOnArray } from 'utils/functions';
import { AuthContext } from 'contexts/AuthContext';
import { DropsContext } from 'contexts/DropsContext';
import { NotificaçõesContext } from 'contexts/NotificaçõesContext';
import { useDrawer } from 'components/Modals';
import Button from 'components/Button';
import NotificacaoModal from 'components/Modals/NotificacaoModal';
import styles from './styles';

const Navbar = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openCollapse, setOpenCollapse] = useState(false);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const { openDrawer: openDrw } = useDrawer();
  const { drops } = useContext(DropsContext);
  const { user, logout } = useContext(AuthContext);
  const { notifications } = useContext(NotificaçõesContext);
  const navigate = useNavigate();
  const filial = findOnArray(user?.filial_id, drops?.Filial, 'label');

  const handleOpenDrawer = () => setOpenDrawer(true);

  const handleOpenUserMenu = (event) => setAnchorElUser(event?.currentTarget);

  const handleCloseNavMenu = () => setOpenDrawer(false);

  const handleCloseUserMenu = () => setAnchorElUser(null);

  const handleNotification = () =>
    openDrw(<NotificacaoModal />, 'Notificações');

  const handleSetting = (action) => {
    if (action) action();
    handleCloseUserMenu();
  };

  const handleMobile = (action) => {
    if (action) action();
    handleCloseNavMenu();
  };

  const badgeContent = notifications?.filter(
    (f) => f?.finalizado === 'NAO'
  )?.length;

  const options = [
    {
      name: 'Início',
      visible: !Boolean(drops?.Logo?.logo),
      action: () => navigate('/app'),
    },
    {
      name: 'Entidades',
      visible: !user?.permissoes?.block_entidades,
      action: () => navigate('/app/Entidades'),
    },
    {
      name: 'Produtos',
      visible: !user?.permissoes?.block_produtos,
      action: () => navigate('/app/Produtos'),
    },
    {
      name: 'Tabelas',
      visible: !user?.permissoes?.block_tabelas,
      action: () => navigate('/app/Tabelas'),
    },
    {
      name: 'Regras',
      visible: !user?.permissoes?.block_regras,
      children: [
        {
          name: 'Preço',
          visible: !user?.permissoes?.block_regras_preco,
          action: () => navigate('/app/Regras/Preco'),
        },
        {
          name: 'CFOP',
          visible: !user?.permissoes?.block_regras_cfop,
          action: () => navigate('/app/Regras/CFOP'),
        },
        {
          name: 'Tributação',
          visible: !user?.permissoes?.block_regras_tributacao,
          action: () => navigate('/app/Regras/Tributacao'),
        },
        {
          name: 'Integração Contábil',
          visible: !user?.permissoes?.block_regras_integracao_contabil,
          action: () => navigate('/app/Regras/IntegracaoContabil'),
        },
      ],
    },
    {
      name: 'Integrações',
      visible: !user?.permissoes?.block_integracoes,
      children: [
        {
          name: 'Bling',
          visible: !user?.permissoes?.block_integracoes_bling,
          action: () => navigate('/app/Integrações/Bling'),
        },
        {
          name: 'Mercado Livre',
          visible: !user?.permissoes?.block_integracoes_mercadolivre,
          action: () => navigate('/app/Integrações/MercadoLivre'),
        },
        {
          name: 'Mercos',
          visible: !user?.permissoes?.block_integracoes_mercos,
          action: () => navigate('/app/Integrações/Mercos'),
        },
        {
          name: 'Shopee',
          visible: !user?.permissoes?.block_integracoes_shopee,
          action: () => navigate('/app/Integrações/Shopee'),
        },
        {
          name: 'WhatsApp',
          visible: !user?.permissoes?.block_integracoes_whatsapp,
          action: () => navigate('/app/Integrações/WhatsApp'),
        },
      ],
    },
  ];

  const settings = [
    {
      name: 'Ajuda',
      visible: true,
      action: () => window.open('https://help.eprom.com.br', '_blank'),
    },
    { name: 'Sair', visible: true, action: () => logout() },
  ];

  return (
    <AppBar position="fixed">
      <Toolbar disableGutters sx={styles?.toolbar}>
        <Box sx={styles?.menuMobile}>
          <IconButton onClick={handleOpenDrawer} color="inherit">
            <MenuIcon />
          </IconButton>
          <Drawer
            anchor="left"
            open={openDrawer}
            onClose={handleCloseNavMenu}
            PaperProps={styles?.menuMobileDrawer}
          >
            <List>
              {options?.map(({ name, visible, action, children }, i) => {
                if (!visible) return null;
                if (Boolean(children?.length)) {
                  return (
                    <Box key={i?.toString()}>
                      <ListItem disablePadding>
                        <ListItemButton
                          onClick={() =>
                            !!openCollapse && openCollapse === name
                              ? setOpenCollapse(false)
                              : setOpenCollapse(name)
                          }
                        >
                          <ListItemText primary={name} />
                          <ListItemIcon sx={styles?.iconList}>
                            {openCollapse === name ? (
                              <KeyboardArrowUp
                                fontSize="small"
                                sx={styles?.icon}
                              />
                            ) : (
                              <KeyboardArrowDown
                                fontSize="small"
                                sx={styles?.icon}
                              />
                            )}
                          </ListItemIcon>
                        </ListItemButton>
                      </ListItem>
                      <Collapse
                        in={openCollapse === name}
                        timeout="auto"
                        unmountOnExit
                      >
                        <List>
                          {children?.map(
                            ({ name, action, visible }, i) =>
                              visible && (
                                <ListItem key={i?.toString()} disablePadding>
                                  <ListItemButton
                                    onClick={() => handleMobile(action)}
                                  >
                                    <ListItemText
                                      primary={name}
                                      sx={styles?.textList}
                                    />
                                  </ListItemButton>
                                </ListItem>
                              )
                          )}
                        </List>
                      </Collapse>
                    </Box>
                  );
                }
                return (
                  <ListItem key={i?.toString()} disablePadding>
                    <ListItemButton onClick={() => handleMobile(action)}>
                      <ListItemText primary={name} />
                    </ListItemButton>
                  </ListItem>
                );
              })}
            </List>
            <Divider sx={styles?.icon} />
            <List>
              {settings?.map((setting) => (
                <ListItem key={setting?.name} disablePadding>
                  <ListItemButton onClick={setting?.action}>
                    <ListItemText primary={setting?.name} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Drawer>
        </Box>
        {Boolean(drops?.Logo?.logo) && (
          <Box sx={styles?.menuMobile}>
            <Box sx={styles?.logoContainer} onClick={() => navigate('/app')}>
              <img src={drops?.Logo?.logo} style={styles?.logo} />
            </Box>
          </Box>
        )}
        <Box sx={styles?.menuWide}>
          {Boolean(drops?.Logo?.logo) && (
            <Box sx={styles?.logoContainer} onClick={() => navigate('/app')}>
              <img src={drops?.Logo?.logo} style={styles?.logo} />
            </Box>
          )}
          {options?.map(({ name, visible, action, children }, i) => {
            if (!visible) return null;
            if (Boolean(children?.length)) {
              const [anchorEl, setAnchorEl] = useState(null);
              return (
                <Box key={i?.toString()} sx={styles?.menuWideButtonContainer}>
                  <Button
                    endIcon={<KeyboardArrowDown fontSize="medium" />}
                    sx={styles?.menuWideButton}
                    onClick={({ currentTarget }) => setAnchorEl(currentTarget)}
                  >
                    {name}
                  </Button>
                  <Menu
                    anchorEl={anchorEl}
                    open={!!anchorEl}
                    onClose={() => setAnchorEl(null)}
                  >
                    {children?.map(
                      ({ name, action, visible }, i) =>
                        visible && (
                          <MenuItem
                            key={i?.toString()}
                            disabled={!anchorEl}
                            onClick={() => {
                              setAnchorEl(null);
                              if (action) action();
                            }}
                          >
                            {name}
                          </MenuItem>
                        )
                    )}
                  </Menu>
                </Box>
              );
            }
            return (
              <Box key={i?.toString()} sx={styles?.menuWideButtonContainer}>
                <Button onClick={action} sx={styles?.menuWideButton}>
                  {name}
                </Button>
              </Box>
            );
          })}
        </Box>
        <Box sx={styles?.notificationContainer}>
          <IconButton onClick={handleNotification}>
            <Badge badgeContent={badgeContent} color="secondary" max={99}>
              <Notifications sx={styles?.icon} />
            </Badge>
          </IconButton>
        </Box>
        <Box sx={styles?.avatarWide}>
          <Tooltip
            title={<Box sx={styles?.tooltip}>{user?.nome + '\n' + filial}</Box>}
            placement="left"
          >
            <IconButton onClick={handleOpenUserMenu}>
              <Avatar alt={user?.nome} src="/static/images/avatar/2.jpg" />
            </IconButton>
          </Tooltip>
          <Menu
            sx={styles?.menuSettings}
            anchorEl={anchorElUser}
            anchorOrigin={styles?.menuSettingsAnchor}
            keepMounted
            transformOrigin={styles?.menuSettingsOrigin}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            {settings?.map(
              ({ action, name, visible }, i) =>
                visible && (
                  <MenuItem
                    key={i?.toString()}
                    disabled={!anchorElUser}
                    onClick={() => handleSetting(action)}
                  >
                    <Typography textAlign="center">{name}</Typography>
                  </MenuItem>
                )
            )}
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
